export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileAktGyogy');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileAktGyogy');
    }
}
